import { useEffect, useState } from "react";
import { Popup, Image } from 'antd-mobile'
import './index.less'
import { useParams } from 'react-router-dom';
import { onReturn } from '@/utils/common'
// 图片
import closePng from '@/image/common/close.png'

const ExplanationCoachLevel = (props:any) => {
  const [visible, setVisible] = useState<boolean>(false)
  const { type }:any = useParams();
  const [context, setContext] = useState<Array<string>>([])

  useEffect(() => {
    setVisible(true)

    setContext(type === 'fitness' ? [
      '健身',
      '98元 - 157元',
      '158元 - 257元',
      '258元 - 497元',
      '498元 - 888元',
      '上月已完成订单总时长大于等于25小时，当前评分大于等于2.5',
      '上月已完成订单总时长大于等于45小时，当前评分大于等于3.0',
      '上月已完成订单总时长大于等于65小时，当前评分大于等于4.0',
      '平台将根据上传的技能认证视频和技能认证证书进行评级审核，最终入驻后的等级将以审核结果为准。',
    ] : [
      '台球',
      '58元 - 88元',
      '89元 - 118元',
      '119元 - 138元',
      '139元 - 388元',
      '上月已完成订单总时长大于等于100小时，当前评分大于等于2.5',
      '上月已完成订单总时长大于等于130小时，当前评分大于等于3.0',
      '上月已完成订单总时长大于等于180小时，当前评分大于等于4.0',
      '平台将根据上传的技能认证视频进行评级审核，最终入驻后的等级将以审核结果为准。',
    ])
  }, [type]);

  return (
    <Popup
      className="explanation-coach-popup"
      visible={visible}
      onMaskClick={() => {
        setVisible(false)
        onReturn()
      }}
      onClose={() => {
        setVisible(false)
        onReturn()
      }}
      bodyStyle={{ height: '72vh' }}
    >
      <header>
        <span />
        <h3>教练等级选择说明</h3>
        <Image src={closePng} onClick={() => {
          setVisible(false)
          onReturn()
        }} />
      </header>

      <section>
        <p>1、入驻时选择的教练等级与课时费设置的接单价格有关联；</p>
        <p>2、自入驻日期开始，每个自然月将进行一次等级评级，首月的等级与入驻时的等级相同，次月将根据上月评级标准进行级别变更，后续评级以此类推；</p>
        <p>3、{context[0]}教练课时费的接单价格设置区间：</p>
        <ul>
          <li><span>教练等级</span><span>可设置的价格区间</span></li>
          <li><span>初级</span><span>{context[1]}</span></li>
          <li><span>中级</span><span>{context[2]}</span></li>
          <li><span>高级</span><span>{context[3]}</span></li>
          <li><span>星级</span><span>{context[4]}</span></li>
        </ul>
        <p>4、评级标准： <br />初级升中级:{context[5]}<br />中级升高级:{context[6]}<br />高级升星级:{context[7]}</p>
        <p>5、{context[8]}</p>
      </section>
    </Popup>
  )
}

export default ExplanationCoachLevel